var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page"},[_vm._m(0),_c('h1',[_c('van-icon',{staticClass:"icon",attrs:{"name":"clear","color":"red"}}),_vm._v(" 500")],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',[_c('img',{staticClass:"img",attrs:{"src":"https://gw.alipayobjects.com/zos/rmsportal/KpnpchXsobRgLElEozzI.svg","alt":"500"}})])
}]

export { render, staticRenderFns }